import {createContext, getContextOrThrow} from 'src/core';
import type {Editor} from '@milkdown/core';
import {type Readable, writable} from 'svelte/store';

const RICHTEXT_AREA_CONTEXT_KEY = Symbol('richtext-area-context-key');

type MarksType = 'bold' | 'italic' | 'strikethrough';

interface RichtextAreaContext {
    editor$: Readable<Editor | null>;
    activeMarks$: Readable<MarksType[]>;
    setEditor: (editor: Editor) => void;
    setActiveMark: (mark: MarksType, active: boolean) => void;
    removeAllActiveMarks: () => void;
}

export function createRichtextAreaContext(): RichtextAreaContext {
    const editor$ = writable<Editor>(null);
    const activeMarks$ = writable<MarksType[]>([]);

    return createContext(RICHTEXT_AREA_CONTEXT_KEY, {
        editor$,
        activeMarks$,
        setEditor: (newEditor) => editor$.set(newEditor),
        setActiveMark: (mark, active) => activeMarks$.update((marks) => {
            if (active) {
                return [...marks, mark];
            }

            return marks.filter((m) => m !== mark);
        }),
        removeAllActiveMarks: () => activeMarks$.set([])
    });
}

export function getRichtextAreaContext(): RichtextAreaContext {
    return getContextOrThrow(RICHTEXT_AREA_CONTEXT_KEY);
}